import * as React from 'react';
import type { SVGProps } from 'react';
const SvgArrowFromBottom = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 13 15"
    {...props}
  >
    <path
      fill="#fff"
      d="m1.594 5.75 4.625-4.625a.36.36 0 0 1 .531 0l4.625 4.625c.156.156.156.406 0 .531l-.625.625c-.125.157-.375.157-.531 0L7.313 3.875v7.75a.38.38 0 0 1-.375.375h-.875a.36.36 0 0 1-.375-.375v-7.75L2.75 6.906c-.156.157-.406.157-.531 0l-.625-.625c-.157-.125-.157-.375 0-.531m10.531 7.625c.188 0 .375.188.375.375v.875a.38.38 0 0 1-.375.375H.875a.36.36 0 0 1-.375-.375v-.875a.38.38 0 0 1 .375-.375z"
    />
  </svg>
);
export default SvgArrowFromBottom;
